import type { SlotMapping } from "@/core/value-objects/StageConfig";

// Devuelve un texto legible basado en la clave de slot y, si se proporciona,
// el mapeo de posiciones definido en la configuración del formato.
export function formatSlotKey(
  slotKey: string | null | undefined,
  mappings?: SlotMapping[] | undefined,
): string {

  if (!slotKey) {
    console.log(slotKey);
    return ""
  }

  const map = mappings?.find((m) => m.slot === slotKey);
  if (map) {
    if (map.source === "GROUP_RANK" && map.group && map.rank != null) {
      let groupText = `${map.rank}º de ${map.group}`;
      console.log(slotKey, groupText);
      
      return groupText;
    }
    if (map.source === "BEST_THIRD" && map.pool) {
      let poolText = `Mejor 3º de ${map.pool.join(",")}`;
      console.log(slotKey, poolText);
      return poolText;
    }
  }

  console.log("No encontro", slotKey);


  return slotKey;
}
